import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadFileComponent } from './upload-file.component';
import { DropZoneModule } from '@motes-sdk/directives';
import { SvgIconModule } from '../svg-icon';
import { MotePipesModule } from '@motes-sdk/pipes';
import { CountUpModule } from 'ngx-countup';

@NgModule({
    declarations: [UploadFileComponent],
    imports: [
        CommonModule,
        DropZoneModule,
        SvgIconModule,
        MotePipesModule,
        CountUpModule
    ],
    exports: [UploadFileComponent]
})
export class UploadFileModule { }
